var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('button',{staticClass:"button",attrs:{"elevation":"0"},on:{"click":_vm.share}},[_c('v-icon',[_vm._v("$shareIcon")]),_c('div',{staticClass:"share-text"},[_vm._v(_vm._s(_vm.$t("game.buttons.share")))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }